import { ReactNode } from "react";

export interface PrimaryButtonProps {
    title: string;
    outlined?: boolean;
    fill?: boolean;
    transparent?: boolean;
    textSize?: 'm' | 'l' | 's';
    onClick: (e: any) => void;
    widthFit?: boolean;
    icon?: ReactNode;
    iconPosition?: "left" | "right";
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = (btn) => {
    return (
        <div className={`${btn.widthFit ? "lg:w-fit" : ""} w-full h-fit`}>
            <button className={`${btn.widthFit ? "lg:w-fit" : ""} w-full px-2 ${btn.outlined ? "border-2 border-primary text-primary hover:text-primary_darker bg-transparent py-1.5 hover:border-primary_darker hover:bg-transparent" : "ring-0 bg-primary text-white py-2"} ${btn.textSize == 'l' ? 'text-lg lg:text-xl' : btn.textSize == 's' ? "text-[15px]" : ""} ${btn.iconPosition === "right" && "flex-row-reverse"} font-medium rounded-xl shadow-sm hover:bg-primary_darker transition duration-150 flex flex-row justify-center items-center`}
            onClick={btn.onClick} type="submit">
                {btn.icon && 
                <div className="h-[26px] w-[26px] mr-1 z-20">
                    {btn.icon}
                </div>
                }
                <div>
                    {btn.title}
                </div>
            </button>
        </div>
    )
}